
let _ua = navigator.userAgent.toLowerCase();
let _o = {
  ltIE6:typeof window.addEventListener == "undefined" && typeof document.documentElement.style.maxHeight == "undefined",
  ltIE7:typeof window.addEventListener == "undefined" && typeof document.querySelectorAll == "undefined",
  ltIE8:typeof window.addEventListener == "undefined" && typeof document.getElementsByClassName == "undefined",
  IE:document.uniqueID,
  Firefox:window.sidebar,
  Firefox2:false,
  Opera:window.opera,
  Webkit:!document.uniqueID && !window.opera && !window.sidebar && !window.orientation && window.localStorage,
  mobile:/android|iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase()),
  iphone:/iphone|ipod/i.test(_ua),
  android:/android/.test(_ua),
  shl21:/shl21/.test(_ua),
  ipad:/ipad/.test(_ua),
  tablet:undefined,
  smartphone:undefined,
  version:0
}

if(!_o.tablet && _o.android){ _o.tablet = !(/mobile/.test(_ua));}
_o.smartphone = _o.iphone || _o.android ? true : false;

if(_o.android)
{
  _o.version = Number(_ua.substr(_ua.indexOf('android')+8, 3));
}

const ua = _o;
	
//タブレットかどうか
const _isTablet = _o.tablet;

//スマホかどうか
const _isSmartPhone = _o.smartphone;

//Androidかどうか
const _isAndroid = _o.android;



const EnvUtil = {
  ua: ua,
  isTablet: _isTablet,
  isSmartPhone: _isSmartPhone,
  isAndroid: _isAndroid
}
export default EnvUtil